import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import CN from './CN';
import EN from './EN';

/**
 * 智能服务条款组件
 * 根据 i18next-browser-languagedetector 检测到的语言自动渲染对应版本
 * - 中文（zh、zh-CN）-> 渲染 CN 组件
 * - 其他语言 -> 渲染 EN 组件
 */
export const SmartTermOfUse: React.FC = () => {
  const { i18n } = useTranslation();
  const [isLoading, setIsLoading] = useState(true);
  const [currentLanguage, setCurrentLanguage] = useState<string>('');

  useEffect(() => {
    // 监听语言变化
    const handleLanguageChange = (lng: string) => {
      // console.log('服务条款语言检测结果:', lng);
      setCurrentLanguage(lng);
      setIsLoading(false);
    };

    // 如果 i18n 已经初始化完成
    if (i18n.isInitialized) {
      handleLanguageChange(i18n.language);
    } else {
      // 等待 i18n 初始化完成
      i18n.on('initialized', handleLanguageChange);
    }

    // 监听语言切换事件
    i18n.on('languageChanged', handleLanguageChange);

    // 清理事件监听器
    return () => {
      i18n.off('initialized', handleLanguageChange);
      i18n.off('languageChanged', handleLanguageChange);
    };
  }, [i18n]);

  // 判断是否为中文
  const isChinese = (language: string): boolean => {
    const chineseLanguages = ['zh', 'zh-CN', 'zh-Hans', 'zh-Hant', 'zh-TW', 'zh-HK'];
    return chineseLanguages.some((lang) => language.toLowerCase().startsWith(lang.toLowerCase()));
  };

  // 加载状态
  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <div className="text-center">
          <div className="mx-auto mb-4 size-8 animate-spin rounded-full border-b-2 border-blue-600"></div>
          <p className="text-gray-600">正在检测语言...</p>
        </div>
      </div>
    );
  }

  // 根据语言渲染对应组件
  const shouldRenderChinese = isChinese(currentLanguage);

  // console.log(`服务条款组件渲染: ${shouldRenderChinese ? '中文版' : '英文版'} (${currentLanguage})`);

  return shouldRenderChinese ? <CN /> : <EN />;
};

export default SmartTermOfUse;
